import { addGlobalListeners } from './listeners/globalListeners';
import { addArticleListeners } from './listeners/articleListeners';
import { addPageLoadEvents } from './listeners/pageLoadEvents';
import { addProductListeners } from './listeners/productListeners';
import { addHeaderCTAListeners } from './listeners/headerCTAListener';
import { addCampaignListeners } from './listeners/selectPromotionListeners';
import { addFormListeners } from './listeners/formListeners';
import { addFileDownloadListeners } from './listeners/fileDownloadListener';
import { addProductReviewsEvents } from './listeners/productReviewsEvents';
import { addGeoLocationsListeners } from './listeners/geoLocationsListeners';

export const addAnalyticsListeners = () => {
  addProductListeners();
  addArticleListeners();
  addPageLoadEvents();
  addGlobalListeners();
  addHeaderCTAListeners();
  addCampaignListeners();
  addFormListeners();
  addFileDownloadListeners();
  addProductReviewsEvents();
  addGeoLocationsListeners();
};
